import NextBlueIcon from 'assets/icons/next-blue.svg';
import { useNavigate } from 'react-router-dom';

interface props {
    link: string;
}

export const DetailPropertyComponent = ({ link }: props) => {
    const navigate = useNavigate();

    return (
        <section
            className="detail-property-link"
            onClick={() => {
                navigate(link);
            }}
        >
            <div>物件の詳細</div>
            <img alt="" src={NextBlueIcon} />
        </section>
    );
};
